import { createSlice } from "@reduxjs/toolkit";

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState: {
    data: [],
    accountsByService: [],
    // productSelected: null,
    accountSelected: null,
    newAccountAddress: null,
    error: false,
    errorContent: null,
    loading: false,
    editMode: false,
    isFiltered: false,
    typeService: null,
  },
  reducers: {
    loadingAccounts: (state) => {
      state.loading = true
    },
    successAccounts: (state, action) => {
      state.loading = false
      state.data = action.payload.map(item => {
        return {
          ...item, name: item.alias
        }
      })
      state.isFiltered = false
    },
    updateAccounts: (state, { payload }) => {
      state.data = state.data.map(item => {
        if(item.id === payload.id) {
          return {...payload}
        } else {
          return {...item}
        }
      })
    },
    loadingError: (state, action) => {
      state.loading = false
      state.error = true
      state.errorContent = action.payload
    },
    newAccount: (state, action) => {
      return {
        ...state,
        data:[...state.data, {...action.payload, name: action.payload.alias}]
      }
    },
    editAccount: (state, {payload}) => {
      
      return {
        ...state, editMode: payload.editMode,
        accountSelected: state.data.filter(item => item.id === payload?.id)
      }
    },
    filterAccountsbyService: (state, { payload }) => {
      state.accountsByService = state.data.filter(item => item.type === payload);
      state.isFiltered = true
    },
    getTypeAccount: (state, { payload }) => {
      state.typeService = payload
    },
    removeAccount: (state, { payload }) => {
      if(payload.all) {
        state.data = state.data.filter(item => item.id !== payload.id)
      } else {
        state.accountsByService = state.accountsByService.filter(item => item.id !== payload)
      }
    },
    newAddressAccount: (state, { payload }) => {
      
    }
    // noEditAccount: 
  }
})

export const { loadingAccounts, successAccounts, updateAccounts, loadingError, newAccount, editAccount, filterAccountsbyService, getTypeAccount, removeAccount, newAddressAccount } = accountsSlice.actions